export enum UserEvent {
  UserUpdated = 'UserUpdatedEvent',
  MessageReceived = 'UserMessageEvent',
}

export enum AiEvent {
  DealsAiSummaryCompleted = 'DealsAiSummaryCompletedEvent',
  PromptCompleted = 'AiPromptCompletedEvent',
}

/**
 * These events are broadcast from App\Incept\CreditBureau\Events, not App\Events, so the leading backslash is
 * required: Echo's event formatter only skips its default `App.Events` namespace for a name that starts with one.
 */
export enum CreditBureauEvent {
  IndividualCreditEnquiryCompleted = '\\App\\Incept\\CreditBureau\\Events\\IndividualCreditEnquiryCompleted',
}

export enum DocumentEvent {
  DocumentError = 'DocumentError',
  DocumentNotification = 'DocumentNotification',
  // TransitionPossible = 'TransitionPossible',
  DocumentStatusChange = 'DocumentStatusChange',
  TransitionPerformed = 'TransitionPerformed',
  Calculated = '\\App\\Events\\CalculatedEvent',
  CalculateFailed = '\\App\\Events\\CalculateFailedEvent',
  DocumentWorkflowSwitch = '\\App\\Events\\DocumentWorkflowSwitchEvent',
  AttachmentUploadStateChanged = 'DocumentAttachmentUploadStateChanged',
  FraudAnalysisUpdated = 'FraudAnalysisUpdated',
}

export enum ListEvent {
  DocumentQueueAssignedEvent = 'DocumentQueueAssignedEvent',
  NoDocumentsToAssignEvent = 'NoDocumentsToAssignEvent',
}
